import React from 'react';

import { Path, useFormContext } from 'react-hook-form';

import { z } from 'zod';

import SegmentInput from 'components/SegmentInput/SegmentInput';

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '../../../../../../components/ui/form';
import { pageFormSchema } from '../../../validation-schema';

type PageFormType = z.infer<typeof pageFormSchema>;

interface BlockSegmentsFieldProps {
  basePath: string;
}

export const BlockSegmentsField: React.FC<BlockSegmentsFieldProps> = ({
  basePath
}) => {
  const { control, watch } = useFormContext<PageFormType>();

  const segmentsPath = `${basePath}.segments` as Path<PageFormType>;
  const segments = (watch(segmentsPath) ?? []) as string[];
  const segmentsArray = Array.isArray(segments) ? segments : [];

  return (
    <FormField
      control={control}
      name={segmentsPath}
      render={({ field: { onChange } }) => (
        <FormItem>
          <FormControl>
            <div data-testid="PagesForm-Block-Segments">
              <SegmentInput
                value={segmentsArray}
                onChange={onChange}
                withRichText={false}
                dataTestId="PagesForm-Block-Segments"
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
